/**
 * A function for sorting strings, case insensitive. Returns a negative number when first string occurs before second, positive when second occurs before first, and 0 when they are equivalent.
 * @param a the first string to be compared.
 * @param b the second string to be compared.
 */
export function caseInsensitiveLocaleCompare(a = '', b = ''): number {
  // Sort so that nulls come at the end
  if (a === null && b === null) {
    return 0;
  } else if (a === null) {
    return 1;
  } else if (b === null) {
    return -1;
  }
  return a.localeCompare(b, undefined, { sensitivity: 'base' });
}

/**
 * A function for sorting numbers. Returns whether or not the first number is smaller than the second number.
 * @param a the first number to be compared.
 * @param b the second number to be compared.
 */
export function compareNumbers(a: number, b: number): number {
  // Sort so that nulls come at the end
  if (a === null && b === null) {
    return 0;
  } else if (a === null) {
    return 1;
  } else if (b === null) {
    return -1;
  }
  return a < b ? -1 : a > b ? 1 : 0;
}
